<script setup>
import { computed } from 'vue';
import { REPLY_EDITOR_MODES } from './constants';

// Responder / Nota interna as in the CrmB reply box: the active mode is a
// small solid pill (teal for replies, amber for notes), the other is plain
// text. Clicking either side toggles the mode, as before.
const props = defineProps({
  mode: {
    type: String,
    default: REPLY_EDITOR_MODES.REPLY,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['toggleMode']);

const isPrivate = computed(() => {
  return props.disabled || props.mode === REPLY_EDITOR_MODES.NOTE;
});

const ACTIVE_REPLY = 'bg-n-brand text-white';
const ACTIVE_NOTE = 'bg-n-amber-9 text-white';
const INACTIVE = 'text-n-slate-11 hover:text-n-slate-12';
</script>

<template>
  <div
    class="flex items-center gap-1.5"
    :class="{ 'cursor-not-allowed opacity-70': disabled }"
  >
    <button
      type="button"
      class="h-6 px-[9px] rounded-[5px] text-xs transition-colors"
      :class="[!isPrivate ? `${ACTIVE_REPLY} font-semibold` : `${INACTIVE} font-medium`]"
      :disabled="disabled"
      @click="isPrivate && $emit('toggleMode')"
    >
      {{ $t('CONVERSATION.REPLYBOX.REPLY') }}
    </button>
    <button
      type="button"
      class="h-6 px-[9px] rounded-[5px] text-xs transition-colors"
      :class="[isPrivate ? `${ACTIVE_NOTE} font-semibold` : `${INACTIVE} font-medium`]"
      :disabled="disabled"
      @click="!isPrivate && $emit('toggleMode')"
    >
      {{ $t('CONVERSATION.REPLYBOX.PRIVATE_NOTE') }}
    </button>
  </div>
</template>
